import React from 'react';

import Root from 'react-modal-sheet';
import { QueueContainer } from './QueueContainer';

export const QueueSheet = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [isDraggingContent, setIsDraggingContent] = React.useState(false);

  const handleContentOnTouchStart = React.useCallback(() => {
    setIsDraggingContent(true);
  }, []);

  const handleContentOnTouchEnd = React.useCallback(() => {
    setIsDraggingContent(false);
  }, []);
  return (
    <Root
      className="!z-audioPlayerQueueMobile md:!z-audioPlayerQueue"
      isOpen={isOpen}
      onClose={onClose}
      disableDrag={isDraggingContent}
    >
      <div onTouchEnd={handleContentOnTouchEnd} onTouchStart={handleContentOnTouchStart}>
        <QueueContainer close={onClose} />
      </div>
    </Root>
  );
};
